// extracted by css-extract-rspack-plugin
var _1 = true;
var _2 = "screen and (max-width: 600px)";
var _3 = "price_block-1oZXh";
var _4 = "money-X5T3b";
var _5 = "price_wrapper-10j21";
var _6 = "price_block__delimiter-NAGOx";
var _7 = "button_clear-3kHr5";
export { _1 as "__esModule", _2 as "mobile", _3 as "price_block", _4 as "money", _5 as "price_wrapper", _6 as "price_block__delimiter", _7 as "button_clear" }
export default { "__esModule": _1, "mobile": _2, "price_block": _3, "money": _4, "price_wrapper": _5, "price_block__delimiter": _6, "button_clear": _7 }
